import * as Service from 'types/service';
import AppConstants from 'constants/AppConstants';

export interface State {
  printForWalkInId?: number;
  partyToPrint?: Service.Party;
  showChoosePrinterModal: boolean;
  showPrintMultipleChitsModal: boolean;
  textToPrint?: string;
}

export const initialState: State = {
  showChoosePrinterModal: false,
  showPrintMultipleChitsModal: false,
  textToPrint: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.CHITS_SET_TEXT_PRINT: {
      return {
        ...state,
        textToPrint: payload,
      };
    }
    case AppConstants.CHITS_CLEAR_TEXT_PRINT: {
      return {
        ...state,
        textToPrint: undefined,
      };
    }

    case AppConstants.CHITS_OPEN_PRINT_MULTIPLE_MODAL:
      return {
        ...state,
        showPrintMultipleChitsModal: true,
      };

    case AppConstants.CHITS_CLOSE_PRINT_MULTIPLE_MODAL:
      return {
        ...state,
        showPrintMultipleChitsModal: false,
      };

    case AppConstants.CHITS_OPEN_CHOOSE_PRINTER_MODAL:
      return {
        ...state,
        showChoosePrinterModal: true,
        partyToPrint: payload,
      };

    case AppConstants.CHITS_CLOSE_CHOOSE_PRINTER_MODAL:
      return {
        ...state,
        showChoosePrinterModal: false,
        partyToPrint: undefined,
      };

    case AppConstants.CHITS_SET_PRINT_FOR_WALKIN_ID:
      return {
        ...state,
        printForWalkInId: payload.id,
      };

    case AppConstants.CHITS_CLEAR_PRINT_FOR_WALKIN_ID:
      return {
        ...state,
        printForWalkInId: undefined,
      };

    default:
      return state;
  }
}
